import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,MDBDataTable  } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip ,PageHeader  } from 'antd';

import adminfaculty from '../adminfaculty/adminfaculty';
import Modalarticletyps from './Modalarticletypes';
import Modalcheckpayment from '../Modalcheckpayment';

import { URL,api } from '../../api';


export default class superadmincheckpayment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[],
            loading:false,
            url:'https://mua.kpru.ac.th/FrontEnd_Conferencekpru/',

        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
      }


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           
       
          api.get('registercon/selectArticleconnpayforadminnew')
           .then(res => {
             console.log(res);
           
             this.setState({ article: res.data,loading: true})

           }) 
         }, 0);

      }


      updateat(){
        setTimeout(() => {
           
          api.get('registercon/selectArticleconnpayforadminnew')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }



    render() {


      const datast = {
        columns: [
          {
            label: '#',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'ชื่อเรื่อง',
            field: 'name_article',
            sort: 'name_article',
            width: 150
          },
          {
            label: 'ผู้เขียนบทความ',
            field: 'name_present',
            sort: 'name_present',
            width: 150
          },
          {
            label: 'สาขา',
            field: 'major_precent',
            sort: 'major_precent',
            width: 150
          },
          {
            label: 'ไฟล์บทความ',
            field: 'send_uploadeword1',
            sort: 'send_uploadeword1',
            width: 150
          },
      
        
        ],
  
  
        rows: [...this.state.article.map((data, i) => (
      
          {
     
  
             list: <>{i+1}</>,
             name_article: <>{data.name_article}</>,
             name_present: <>{data.name_present}</>,
             major_precent: <>{data.major_precent}</>,
             send_uploadeword1: <><MDBBtn color="indigo" size="sm" href={`${this.state.url+data.send_uploadeword1}`}  target="_blank">WORD</MDBBtn> <MDBBtn color="pink" size="sm" href={`${this.state.url+data.send_uploadepdf1}`}  target="_blank">PDF</MDBBtn></>,
            
          }
         ))]
    
        };
            const persons = <MDBDataTable
          // searching ={true}
            searchLabel="ค้นหา ชื่อ-นามสกุล"
            striped
            bordered
            small 
            entries={50}
          // entriesOptions={["10", "20"]}
            order={["age", "desc"]}
            data={datast}
            entriesLabel="จำนวนที่แสดง "
            infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
            paginationLabel={["ย้อนกลับ", "ถัดไป"]}
            responsive 
            sortRows={['random']}
             theadColor="grey lighten-1"
          //  theadColor={"#ff4444"}
            />
     
        return (
            <MDBContainer>
            <div>
        
            <p className="text-right font-weight-bold">สวัสดีคุณ : {localStorage.getItem('nameuser')} (ผู้ดูแลระบบกลาง)</p>
            {/* <p className="text-right">การประชุมวิชาการระดับชาติ สำหรับนักศึกษา ครั้งที่ 4 สถาบันวิจัยและพัฒนา มหาวิทยาลัยราชภัฏกำแพงเพชร</p>  */}
         
               {/* <MDBAlert color="success" >
                   <h2> <MDBIcon far icon="file-alt" /> ตรวจสอบการชำระเงิน</h2>
                </MDBAlert> */}
                <MDBAlert color="secondary" >
                   {/* <h2> <MDBIcon far icon="file-alt" /> ข้อมูลผู้ทรงคุณวุฒิ</h2> */}
               
                 
                   
                        <PageHeader
                        className="site-page-header"
                       // onBack={() => null}
                        title="บทความอยู่ระหว่างการชำระเงิน"
                        subTitle="บทความอยู่ระหว่างการชำระเงิน"
                        avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/8107/8107808.png' }}
                    />
                  
   </MDBAlert>




{this.state.loading === false ?<>
<div className="text-center spinner-grow text-success " role="status">
              <span className="sr-only">Loading...</span>
            </div>
</>:<>
          {persons}
                {/* <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>ผู้เขียน</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความ</th>
                        <th>สถานะ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                      
                    {this.state.article.map((article,index )  => 
                    
                        <tr>
                        <td>{index+1}</td>
                        <td>{article.name_article}</td>
                        <td>{article.name_present}</td>
                        <td>{article.major_precent}</td>
                            <td>
                            <MDBBtn color="indigo" size="sm" href={`${this.state.url+article.send_uploadeword1}`}  target="_blank">WORD</MDBBtn>
                             <MDBBtn color="pink" size="sm" href={`${this.state.url+article.send_uploadepdf1}`}  target="_blank">PDF</MDBBtn>
                            </td>
                        <td>  
                         
                           <p  className="orange-text font-weight-bold"><MDBIcon fas icon="dollar-sign" /> อยู่ระหว่างชำระเงิน</p>
                           </td>
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable> */}

</>}
             
               
            </div>
            </MDBContainer>
        )
    }
}
